import api from '../interceptors/axiosInterceptor';
import { executeApiCall } from '../utils/apiUtils';

// Function to show error message using the error context
const showApiError = (error) => {
  // Dispatch custom event for error context
  window.dispatchEvent(new CustomEvent('showApiError', { 
    detail: { 
      message: error.message || 'An error occurred while processing your request.',
      subMessage: error.response?.data?.message || 'Please try again later.'
    } 
  }));
};

// Generic API methods
export const apiService = {
  
  // UserAPi
   GetAllUsers: async () => {
    try {
      const response = await api.get('User/GetAllUsers');
      return response.data;
    } catch (error) {
      console.error('GetAllUsers API error:', error);
      throw error;
    }
  },
  addOrUpdateUser: async (userData) => {
    try {
      const response = await api.post('/User/AddUpdateUser', userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  GetAllRoles: async (st) => {
    try {
      const response = await api.get(`Role/GetAllRoles/${st}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  AddRole: async (roleData) => {
    try {
      const response = await api.post('Role/AddUpdateRole', roleData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  UpdateRole: async (roleData) => {
    try {
      const response = await api.post('Role/AddUpdateRole', roleData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  GetAllPermissions: async () => {
    try {
      const response = await api.get('Role/GetAllPermissions');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete role by ID
  DeleteRoleByID: async (id) => {
    try {
      const response = await api.delete(`Role/DeleteRole/${id}/false`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // GET request
  get: async (url, config = {}) => {
    try {
      const response = await api.get(url, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // POST request
  post: async (url, data = {}, config = {}) => {
    try {
      const response = await api.post(url, data, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // PUT request
  put: async (url, data = {}, config = {}) => {
    try {
      const response = await api.put(url, data, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // DELETE request
  delete: async (url, config = {}) => {
    try {
      const response = await api.delete(url, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // PATCH request
  patch: async (url, data = {}, config = {}) => {
    try {
      const response = await api.patch(url, data, config);
      return response.data;
    } catch (error) {
      throw error;
    }
  },


  GetAllSites: async () => {
    try {
      const response = await api.get('Site/GetAllSites');
      return response.data;
    } catch (error) {
      throw error;
    }
  },


  DeleteSiteByID: async (id) => {
    try {
      const response = await api.delete(`Site/DeleteSite/${id}/false`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  

  GetAllRegions: async () => {
    try {
      const response = await api.get('Region/GetAllRegions');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  CreateSite: async (siteData) => {
    try {
      const response = await api.post('Site/AddUpdateSite', siteData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  //RegionsAPi
  GetAllRegions: async () => {
    try {
      const response = await api.get('Region/GetAllRegions');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  DeleteRegionByID: async (id) => {
    try {
      const response = await api.delete(`Region/DeleteRegion/${id}/false`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  AddAndUpdateRegion: async (regionData) => {
    try {
      const response = await api.post('Region/AddUpdateRegion', regionData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  GetAllCompanies: async (st) => {
    return executeApiCall(
      async () => {
        const response = await api.get(`Company/GetAllCompany/${st}`);
        return response.data;
      },
      'GetAllCompanies'
    );
  },

  GetCompaniesById: async(id) =>{
    return executeApiCall(
      async () => {
        const response = await api.get(`Company/GetCompanyById/${id}`);
        return response.data;
      },
      'GetCompaniesById'
    );
  },

  AddAndUpdateCompany: async (companyData) => {
    try {
      const response = await api.post('Company/AddUpdateCompany', companyData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  DeleteCompanyByID: async (id) => {
    try {
      const response = await api.delete(`Company/DeleteCompany/${id}/false`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

//SystemConfigAPi

GetSystemConfig: async () => {
  try {
    const response = await api.get('SystemConfig/GetAllSystemConfig');
    return response.data;
  } catch (error) {
    throw error;
  }
},

AddAndUpdateSystemConfig: async (systemConfigData) => {
  try {
    const response = await api.post('SystemConfig/AddUpdateSystemConfig', systemConfigData);
    return response.data;
  } catch (error) {
    throw error;
  }
},


DeleteSystemConfig: async(id)=>{
  try {
    const response = await api.delete(`SystemConfig/DeleteSystemConfig/${id}/false`);
    return response.data;
  } catch (error) {
    throw error;
  }
},
GetSystemConfigByID: async(id)=>{
  try {
    const response = await api.get(`SystemConfig/GetSystemConfigByCompanyId/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
},

 GetSystemConfigByUSerid: async(id)=>{
try{
  const response = await api.get(`SystemConfig/GetUserData/${id}`);
  return response.data;
}catch (error){
 throw error
}
 },

 FinalizeAnalysis: async (analysisId, userId, finalizedByUserId) => {
   try {
     const response = await api.post('SystemConfig/FinalizeAnalysis', {
       AnalysisId: analysisId,
       UserId: userId,
       FinalizedByUserId: finalizedByUserId
     });
     return response.data;
   } catch (error) {
     throw error;
   }
 },
 
  GetAllEnginePricing: async () => {
    return executeApiCall(
      async () => {
        const response = await api.get('MasterData/GetAllEnginePricing');
        return response.data;
      },
      'GetAllEnginePricing'
    );
  },

  GetAllTransmissionPricing: async () => {
    return executeApiCall(
      async () => {
        const response = await api.get('MasterData/GetAllTransmissionPricing');
        return response.data;
      },
      'GetAllTransmissionPricing'
    );
  },

  GetAllsales: async () => {
    return executeApiCall(
      async () => {
        const response = await api.get('MasterData/GetAllsales');
        return response.data;
      },
      'GetAllsales'
    );
  },

  GetAllInventory: async () => {
    try {
      const response = await api.get('MasterData/GetAllInventory');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  GetAllDemandData: async (demandReportInput) => {
    return executeApiCall(
      async () => {
        const response = await api.post('MasterData/GetAllDemandData', demandReportInput);
        return response.data;
      },
      'GetAllDemandData'
    );
  },
  GetfilterDataForDemand: async () => {
    return executeApiCall(
      async () => {
        const response = await api.get('MasterData/GetfilterDataForDemand');
        return response.data;
      },
      'GetfilterDataForDemand'
    );
  },
  GetAllStock: async () => {
    return executeApiCall(
      async () => {
        const response = await api.get('MasterData/GetAllStock');
        return response.data;
      },
      'GetAllStock'
    );
  },

  GetPriceLineConfig: async () => {
    return executeApiCall(
      async () => {
        const response = await api.get('MasterData/GetPriceLineConfig');
        return response.data;
      },
      'GetPriceLineConfig'
    );
  },

  GetAllTbGroup: async () => {
    return executeApiCall(
      async () => {
        const response = await api.get('TBGroup/GetAllTBGroups');
        return response.data;
      },
      'GetAllTbGroup'
    );
  },

  // GetAllTBVariables: async () => {
  //   try {
  //     const response = await api.get('TBGroup/GetAllTBVariables');
  //     return response.data;
  //   } catch (error) {
  //     throw error;
  //   }
  // },

  UpdateTbGroup: async (tbGroupData) => {
    try {
      const response = await api.put('TBGroup/UpdateWeightage', tbGroupData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  UpdatePriceLineConfig: async (priceLineConfigData) => {
    try {
      const response = await api.put('MasterData/UpdatePriceLineConfig', priceLineConfigData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // TB Group APIs
  GetAllTBModels: async () => {
    return executeApiCall(
      async () => {
        const response = await api.get('TBGroup/GetAllTBModels');
        return response.data;
      },
      'GetAllTBModels'
    );
  },

  GetAllTBVariables: async () => {
    return executeApiCall(
      async () => {
        const response = await api.get('TBGroup/GetAllTBVariables');
        return response.data;
      },
      'GetAllTBVariables'
    );
  },

  // ML APIs
  GetAllModelType: async () => {
    return executeApiCall(
      async () => {
        const response = await api.get('MasterData/GetAllModelType');
        return response.data;
      },
      'GetAllModelType'
    );
  },

  TrainModel: async (mlModel, variable, partType) => {
    try {
      const response = await api.post('ML/TrainModel', {
        ml_model: mlModel,
        variable: variable,
        part_type: partType
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  Predict: async (mlModel, variable, input, partType) => {
    try {
      const response = await api.post('ML/Predict', {
        ml_model: mlModel,
        variable: variable,
        input: input,
        part_type: partType
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  CheckModelExists: async (mlModel, variable, partType) => {
    try {
      const response = await api.post('ML/CheckModelExists', {
        ml_model: mlModel,
        variable: variable,
        part_type: partType
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Impact Analysis APIs
  GetFinalisedData: async () => {
    try {
      const response = await api.get('MasterData/GetFinalisedData');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  //Historical Sales APIs
  GethistoricalSales: async (isRevenue) => {
    try {
      const response = await api.get(`MasterData/GethistoricalSales/${isRevenue}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  GetPriceComparativeFilterData: async (data) => {
    try {
      const response = await api.post(`MasterData/GetPriceComparativeFilterData`,data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  GetSearchSummary: async (data) => {
    try {
      const response = await api.post(`MasterData/GetSearchSummary`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },  


  // price Predicting r APIs
  GetPricePredictingR: async (data) => {
    try {
      const response = await api.post('ML/PridictPriceByBaseVariable', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
 


  //Analysis Save
  SaveAnalysis: async (data) => {
    debugger;
    try {
      const response = await api.post('Controls/SaveAnalysis', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

 
  GetAllAnalysisBYUSerID: async (userId) => {
    return executeApiCall(
      async () => {
        const response = await api.get(`Controls/GetControlsByUserId/${userId}`);
        return response.data;
      },
      'GetAllAnalysisBYUSerID'
    );
    
  },

  GetValidAnalysisSalesInventoryData: async () => {
    try {
      const response = await api.get('MasterData/Get_validAnalysis_sales_inventory_data');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  Getjob_lookup: async () => {
    try {
      const response = await api.get('MasterData/Data_Sufficiency_for_Analysis');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

   UpdateBatch: async (batchData) => {
    try {
      const response = await api.post('/BatchExpertQueue/UpdateBatch', batchData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Add Model Type API
  AddModelType: async (modelData) => {
    try {
      const response = await api.post('MasterData/AddModelType', modelData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Batch Pricing API methods
  StartBatchPricing: async () => {
    try {
      const response = await api.post('/Controls/StartBatchPricing');
      return response.data;
    } catch (error) {
      console.error('StartBatchPricing API error:', error);
      throw error;
    }
  },

  GetJobStatus: async () => {
    try {
      const response = await api.get('/Controls/GetJobStatus');
      return response.data;
    } catch (error) {
      console.error('GetJobStatus API error:', error);
      throw error;
    }
  },

  ResetJobStatus: async () => {
    try {
      const response = await api.post('/Controls/ResetJobStatus');
      return response.data;
    } catch (error) {
      console.error('ResetJobStatus API error:', error);
      throw error;
    }
  },

  GetBatchPricingResults: async (page = 1, pageSize = 10) => {
    try {
      const response = await api.get(`/Controls/GetBatchPricingResults?page=${page}&pageSize=${pageSize}`);
      return response.data;
    } catch (error) {
      console.error('GetBatchPricingResults API error:', error);
      throw error;
    }
  }

  
};


export default apiService; 